import LoadableImage from "../LoadableImage";
import Navigation from "../Navigation";
import BackLink from "../BackLink";
import ForwardLink from "../ForwardLink";
import {useEffect} from "react";

function Page37() {
  useEffect(() => {
    document.title = "Маяк — Страница 36"
  }, []);

  return (
    <>
      <Navigation />

      <div className="NavigationLink-wrapper">
        <BackLink href="/page35" />
        <ForwardLink href="/page37" />
      </div>

      <p style={{ textAlign: "right" }}>36.</p>
      <p>
        Он смотрит вверх, на СВЕТ, волшебным образом кружащийся<br/>
        сквозь чугунную линзовую панель. Это красиво. Гипнотически.<br/>
        СВЕТ ПРИТЯГИВАЕТ ЕГО...
      </p>
      <p>Но есть что-то еще... <i>другой шум...</i></p>
      <p>Шепот.</p>
      <p>Сверху.</p>
      <p>В ФОНАРНОМ ОТДЕЛЕНИИ.</p>
      <p>
        МОЛОДОЙ пытается заглянуть сквозь железные решетки линзовой панели:<br/>
        яркий СВЕТ лампы мешает смотреть... ему нужно<br/>
        подойти поближе...
      </p>
      <p>Он хватает стул из тени и встает на него.</p>
      <p>Слушает.</p>
      <p>
        Шепот более слышим, хотя трудно разобрать. Он<br/>
        слушает, пытаясь заглушить белый шум от фонаря:
      </p>
      <p>Да, это СТАРИК, но МОЛОДОЙ слышит только обрывки шепота.</p>
      <p style={{ textAlign: "center" }}>
        СТАРИК<br/>
        (шепчет)<br/>
        Свет... семя...
      </p>
      <p>
        Теперь, когда его слух стал более сосредоточенным, раздается еще один шум.<br/>
        Это звук липкой, потной, шлепающейся плоти. Постоянный...
      </p>
      <p>Так знакомо...</p>
      <p>
        Он приближает лицо к решеткам и сквозь проблески<br/>
        света и тени наверху видит:
      </p>
      <p>
        СТАРИКА, В ТЕНИ И ВНЕ ЕЕ. ЕГО ЖИЛИСТЫЙ ТОРС<br/>
        ВИБРИРУЕТ. ПРАВАЯ РУКА ДВИГАЕТСЯ. ЭНЕРГИЧНО. ВВЕРХ. ВНИЗ. ВВЕРХ.<br/>
        ВНИЗ.
      </p>
      <p><i>Он...?</i></p>
      <p>В ЭТОТ МОМЕНТ БЕЛАЯ, ВЯЗКАЯ ЖИДКОСТЬ КАПАЕТ С РЕШЕТОК...</p>
      <p>С ОТВРАЩЕНИЕМ МОЛОДОЙ БЫСТРО УВОРАЧИВАЕТСЯ ОТ ЭТОГО.</p>
      <p>ОН СНОВА СМОТРИТ ВВЕРХ...</p>
      <p>
        ОГРОМНОЕ, СКЛИЗКОЕ, ПОЛУПРОЗРАЧНОЕ <u>ЩУПАЛЬЦЕ</u> <u>КАЛЬМАРА</u> СКОЛЬЗИТ<br/>
        ПО ЖЕЛЕЗНЫМ КОНСТРУКЦИЯМ...
      </p>
      <p>...ОНО ИСЧЕЗАЕТ В ТЕМНОТЕ.</p>
      <p style={{ textAlign: "right" }}>36.</p>
      
      <Navigation />
      
      <div className="NavigationLink-wrapper">
        <BackLink href="/page35" />
        <ForwardLink href="/page37" />
      </div>

      <LoadableImage
        src="https://res.cloudinary.com/linuxmachinecloud/image/upload/v1710021224/the-lighthouse-script/ftfxtv49zovkcomey4ce.jpg"
        alt="Иллюстрация"
      />
    </>
  );
}

export default Page37;
